import { CountryID, CurrencyCode } from "@al/base-lib";

import { ChannelType } from "./types";
/**
 * 兜底国家配置
 */
export const defaultCountryAddress: Partial<Record<CountryID, { provinceId: number; provinceName: string }>> = {
  [CountryID.DE]: { provinceId: 170003, provinceName: "Berlin" },
  [CountryID.BE]: { provinceId: 170865, provinceName: "Bruxelles (19 communes)" },
  [CountryID.ES]: { provinceId: 160010, provinceName: "Comunidad de Madrid" },
  [CountryID.PL]: { provinceId: 170898, provinceName: "Mazowieckie" },
  [CountryID.FR]: { provinceId: 170493, provinceName: "Paris" },
  [CountryID.IT]: { provinceId: 170703, provinceName: "Roma" },
};

/**
 * 请求分期计划配置
 */
// FIXME: 西班牙，比利时，法国，意大利，波兰，按照固定的配置, 白名单暂不做
export const needInstallmentConfig: Partial<Record<CountryID, boolean>> = {
  [CountryID.DE]: false,
  [CountryID.BE]: true,
  [CountryID.ES]: true,
  [CountryID.PL]: true,
  [CountryID.FR]: true,
  [CountryID.IT]: true,
  [CountryID.ID]: true,
};

/**
 * 货币兼容配置，只有波兰和其他国家货币不一致，波兰商品在其他国家需要显示商品不存在，切换到波兰，其他国家的商品显示商品不存在。
 */
export const currencyConfig: Partial<Record<CountryID, CurrencyCode>> = {
  [CountryID.DE]: CurrencyCode.DE,
  [CountryID.BE]: CurrencyCode.BE,
  [CountryID.ES]: CurrencyCode.ES,
  [CountryID.PL]: CurrencyCode.PL,
  [CountryID.FR]: CurrencyCode.FR,
  [CountryID.IT]: CurrencyCode.IT,
};

/**
 * base 接口报错时，一些错误码需要特殊处理
 */
export const baseErrorCode: Record<string, string> = {
  "10210400200030": "商品已禁用",
  "10210400200031": "商品已删除",
};

export const pushNum = "M_product_push_num";

export const adjustLink = {
  [ChannelType.Normal]: (actionKey: string, spuId: string, skuId: string): string => {
    return `https://w2d4.adj.st/silvrr.akulaku.com?actionKey=${actionKey}&adj_t=yjl77q9_j8juo3y&adj_deep_link=silvrr%3A%2F%2Fsilvrr.akulaku.com%3FactionKey%3D${actionKey}&adj_campaign=${spuId}&adj_adgroup=${skuId}`;
  },
  [ChannelType.Iprice]: (actionKey: string, spuId: string, skuId: string): string => {
    return `https://w2d4.adj.st/silvrr.akulaku.com?actionKey=${actionKey}&adj_t=hwppb2g_h8q67pv&adj_deep_link=silvrr%3A%2F%2Fsilvrr.akulaku.com%3FactionKey%3D${actionKey}&adj_campaign=${spuId}_2&adj_adgroup=${skuId}`;
  },
  [ChannelType.Priceza]: (actionKey: string, spuId: string, skuId: string): string => {
    return `https://w2d4.adj.st/silvrr.akulaku.com?actionKey=${actionKey}&adj_t=qs6dzy2_hnmb00y&adj_deep_link=silvrr%3A%2F%2Fsilvrr.akulaku.com%3FactionKey%3D${actionKey}&adj_campaign=${spuId}_2&adj_adgroup=${skuId}`;
  },
};

export const DKMap: Record<string, { keywords: string; description: string }> = {
  "20000": {
    keywords:
      "sandal pria slip、sepatu sneakers pria、kaos pria、jaket hoodie、topi baseball、celana jeans、celana slim fit、tas ransel、tas selempang、kacamatan korea style、kaos kaki",
    description:
      "Temukan gaya pria terbaru dan hemat lebih banyak dengan penawaran eksklusif di Akulaku. Dapatkan pakaian, sepatu, dan aksesori terkini untuk tampilan stylish Anda!",
  },
  "20007": {
    keywords:
      "hp tanpa dp、smartphone、hp terbaru、hp oppo、hp samsung、hp murah、hp vivo、hp realme、hp iphone、powerbank fast charging、powerbank garansi resmi、earphone bluetooth、Case hp、case airpods",
    description:
      "Berbagai pilihan hp dan aksesori terkini dengan keuntungan menarik, seperti DP Rp0 dan gratis ongkir, hanya di Akulaku！Tanpa beban keuangan dan nikmati pengalaman belanja online yg lebih mudah dan terjangkau.",
  },
  "20009": {
    keywords:
      "AC low watt、AC gratis pemasangan、kulkas 2 pintu、kulkas 1 pintu、smart led tv、digital tv、digital led tv HD、Kipas angin、kipas angin dinding、dispenser panas dingan、Mesin cuci terbaru、Rice cooker garansi resmi、Set  top box TV、setrika listrik",
    description:
      "Temukan kualitas terbaik dari produk rumah tangga seperti TV, kulkas, dan AC di Akulaku. Anda dapat membawa pulang peralatan elektronik yang canggih tanpa harus khawatir ongkir.",
  },
  "20015": {
    keywords:
      "Sepeda gunung、sepeda listrik、speaker bluetooth portable、headset bluetooth、headset gaming、camera free memo、playstation",
    description:
      "Akulaku bisa penuhi kebutuhan digital Anda. Nikmati digital produk dari playstation、speaker sampai kamera dan banyak lainnya dengan  penawaran istimewa.",
  },
  "20025": {
    keywords:
      "laptop mulus slim、laptop gaming、komputer desktop、Tablet PC asli、Monitor LED、Printer scan copy all in one、printer wireless、Mouse wireless、Printer bluetooth",
    description:
      "Dengan berbagai pilihan komputer dan perangkat pendukungnya, temukan solusi terbaik untuk kebutuhan Anda tanpa ribet.",
  },
  "20031": {
    keywords:
      "Kasur spring bed、kasur lipat busa、lemari pakaian、set lemari pakaian、Sofabed terlaris、sofa sudut、Buffet tv、lemari tv、lemari dapur、kitchen set、Set sapu lantai、alat pel lantai",
    description:
      "Tingkatkan kenyamanan rumah Anda dengan koleksi terlengkap perabotan dan dekorasi interior di Akulaku. ",
  },
  "20058": {
    keywords:
      "pakaian wanita terbaru、sepatu sneakers、sandal wanita、sepatu flats、celana jeans kaki lebar、celana jeans high waist、celana kulot、daster jumbo、Setelan wanita、pakaian dalam wanita、kacamata hitam",
    description:
      "Temukan gaya eksklusif Anda dengan koleksi pakaian, aksesoris, dan sepatu wanita terbaru di Akulaku. Tampilkan keunikan Anda dalam berbagai tren fashion yang stylish dan terjangkau.",
  },
  "20064": {
    keywords: "Kopi kapal api、Tea jus、beras termurah、camilan organik、indomie、makanan pokok、mie instan",
    description:
      "Belanja Makanan dan Minuman secara online di Akulaku untuk memenuhi kebutuhan Anda dengan berbagai pilihan produk yang berkualitas.",
  },
  "20078": {
    keywords:
      "masker duckbill、paket whitening series、body lotion、skincare、minuman kolagen、pasta gigi、lipstik lip cream、lipstikk waterproof、lipstik tahan lama、parfum wanita",
    description: "Dapatkan semua yang Anda butuhkan, mulai dari perawatan kulit hingga kosmetik, hanya di Akulaku.",
  },
  "20101": {
    keywords:
      "Ban motor、sepasang ban、Helm motor、helm dewasa、helm full face、Aki motor、oli motor、Jas hujan、sarung tangan motor",
    description:
      "Dari helm, ban, sarung tangan, hingga jas hujan, kami menawarkan produk berkualitas dengan harga terjangkau. Beli sekarang di Akulaku dan nikmati diskon menarik!",
  },
  "20111": {
    keywords:
      "paket hemat pampers babi、popok bayi、powder telon、minyak kayu putih、baby powder、susu pertumbuhan、susu formula、pakaian bayi、sepatu anak、stroller bayi、botol susu",
    description:
      "Akulaku adalah destinasi belanja terpercaya untuk kebutuhan ibu dan bayi. Dapatkan produk berkualitas dari merek-merek ternama untuk memastikan kenyamanan dan kesejahteraan bayi Anda",
  },
  "20119": {
    keywords: "",
    description: "",
  },
  "20120": {
    keywords:
      "Sepeda、sepeda anak、alat pancing、joran pancing、kursi lipat、tenda camping、tenda lipat、Senter LED、matras camping、tas gunung、paket badmintion、treadmill elektrik twen",
    description:
      "Dapatkan pilihan lengkap perlengkapan olahraga dan outdoor terbaik untuk memenuhi kebutuhan petualangan dan gaya hidup aktif Anda",
  },
  "20125": {
    keywords: "alat musik、gitar elektrik",
    description:
      "Temukan beragam produk unik dan kualitas terbaik untuk memenuhi segala macam hobi Anda, dari alat musik hingga , semua ada di Akulaku",
  },
  "70223": {
    keywords:
      "tas ransel pria、tas selempang pria、tas totetag wanita、tas selempang wanita、tas ransel wanita、tas penyimpanan、kotak penyimpanan",
    description:
      "Beli bermacama-macam tas dan produk penyimpanan dengan harga spesial. Selain itu, kami menyediakan opsi pembayaran yang fleksibel, sehingga Anda dapat membeli produk impian Anda tanpa beban finansial.",
  },
  "70274": {
    keywords:
      "jam tangan pria、jam tangan wanita、jam tangan anti-air、jam tangan wanita original、Jam tangan wanita terbaru、jam tangn pria original、jam tangan couple",
    description:
      "Dapatkan jam tangan berkualitas tinggi untuk pria dan wanita di Akulaku. Dengan pilihan jam tangan dari berbagai merek terkenal seperti Seiko, Alba, Casio, Alexandre Christie, Eiger, dan banyak lagi.",
  },
  "70294": {
    keywords:
      "hijab instan、hijab segi empat、mukena deawasa、mukena anak、gamis wanita、gamis couple pasangan、gamis pria、baju koko、 peci 、koko anak",
    description: "Eksplorasi gaya fashion muslim yang beragam dan harga murah di Akulaku.",
  },
};
